
import { QueryClient, useMutation } from '@tanstack/react-query'
import {
  agentVerify,
  createAccount,
  createAccountV3,
  createAffiliateCode,
  generateVerificationCode,
  getUserPersona,
  login,
  req90DaysChange,
  verifyAgent,
  verifyEmail,
} from './apis'
import { PublicClientApplication } from '@azure/msal-browser'
import { config } from '../../config'

const publicClientApplication = new PublicClientApplication({
  auth: {
    clientId: config.appId,
    redirectUri: config.redirectUri,
    authority: config.authority,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
})

export const MutateLogin = () => {
  return useMutation({
    mutationKey: 'login',
    mutationFn: login,
  })
}

export const MutateUserPersona = () => {
  return useMutation({
    mutationKey: 'userPersona',
    mutationFn: getUserPersona,
  })
}

export const MutateGenerateVerificationCode = () => {
  return useMutation({
    mutationKey: 'generateVerificationCode',
    mutationFn: generateVerificationCode,
  })
}

export const MutateVerifyEmail = () => {
  return useMutation({
    mutationKey: 'verifyEmail',
    mutationFn: verifyEmail,
  })
}

export const MutateVerifyAgent = () => {
  return useMutation({
    mutationKey: 'verifyAgent',
    mutationFn: verifyAgent,
  })
}

const ssoLogin = async () => {
  await publicClientApplication.initialize()
  try {
    let name = ''
    await publicClientApplication
      .loginPopup({
        scopes: config.scopes,
        prompt: 'select_account',
      })
      .then(function (loginResponse) {
        name = loginResponse.account['name']
      })
    const splitName = name.split(' ', 2)
    return {
      firstName: splitName[0],
      lastName: splitName[1],
    }
  } catch (err) {
    throw new Error(err)
  }
}

export const MutateSSOLogin = () => {
  return useMutation({
    mutationKey: 'ssoLogin',
    mutationFn: ssoLogin,
  })
}

export const MutateReq90DaysChange = () => {
  return useMutation({
    mutationKey: 'req90DaysChange',
    mutationFn: req90DaysChange,
  })
}

export const MutateCreateAffiliateCode = () => {
  return useMutation({
    mutationKey: 'createAffiliateCode',
    mutationFn: createAffiliateCode,
  })
}

export const MutateCreateAccount = () => {
  return useMutation({
    mutationKey: 'createAccount',
    mutationFn: createAccount,
  })
}

export const MutateAgentVerify = () => {
  return useMutation({
    mutationKey: 'agentVerify',
    mutationFn: agentVerify,
  })
}

export const MutateCreateAccountV3 = () => {
  return useMutation({
    mutationKey: 'createAccountV3',
    mutationFn: createAccountV3,
  })
}